// extracted by mini-css-extract-plugin
module.exports = {"container":"StatsCards_container__1Gg3_","content":"StatsCards_content__2Hhu2"};